import { render, staticRenderFns } from "./IELTSTimeManagerComponent.vue?vue&type=template&id=f33358a2&scoped=true&"
import script from "./IELTSTimeManagerComponent.vue?vue&type=script&lang=js&"
export * from "./IELTSTimeManagerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33358a2",
  null
  
)

export default component.exports